import { jsx as _jsx } from "react/jsx-runtime";
import { User as UserIcon } from 'lucide-react';
export function Avatar({ src, size = 48, className = '', borderColor, style: extraStyle }) {
    const style = {
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        borderRadius: '50%',
        flexShrink: 0,
        ...(borderColor ? { border: `2px solid ${borderColor}` } : {}),
        ...extraStyle,
    };
    if (src) {
        return (_jsx("img", { src: src, alt: "", loading: "lazy", className: `object-cover ${className}`, style: style }));
    }
    return (_jsx("div", { className: `flex items-center justify-center bg-white/[.06] ${className}`, style: style, children: _jsx(UserIcon, { size: size * 0.4, className: "text-white/50" }) }));
}
